/** Turn a supabase.functions.invoke error into one carrying the server's own message. */
export async function readInvokeError(err: any): Promise<any> {
  if (!err) return err;
  try {
    const body = await err.context?.json?.();
    const msg = body?.message || body?.error;
    if (msg) return { ...err, message: msg };
  } catch { /* body not JSON */ }
  return err;
}
